import React from 'react';
import { Controller } from 'react-hook-form';

import NoteArea from 'components/note/NoteArea';
import { IControlledFormField } from '../types';

interface IProps extends IControlledFormField {
  placeHolder?: string;
  percentWith?: number;
}

export const ControlledNoteArea: React.FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <Controller
      defaultValue=""
      control={props.control}
      name={props.name}
      rules={props.validations}
      render={(ctrlProps: any) => (
        <NoteArea
          disabled={props.disabled}
          customStyles={{ input: { zIndex: 0 } }}
          width={props.percentWith && `${props.percentWith}%`}
          defaultPlaceholder={props.placeHolder}
          input={{
            value: ctrlProps?.field?.value,
            onChange: ctrlProps?.field?.onChange,
            onBlur: ctrlProps?.field?.onBlur,
          }}
          meta={props.inputMetaData || {}}
          data-qa-id={props.qaId}
        />
      )}
    />
  );
};
